import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Container } from 'reactstrap';

import FooterBanner from 'Layout/Footer/FooterBanner';

import 'Layout/Footer/PreviewFooterBanner.scss';

const PreviewFooterBanner = ({
  footer,
}) => {
  if (isEmpty(footer)) return false;

  const background = footer.images.find(img => img.img_type === 'footer_background');
  const mobileBackground = footer.images.find(img => img.img_type === 'footer_mobile_background');
  const foreground = footer.images.find(img => img.img_type === 'footer_foreground');

  return (
    <div className="preview-footer-banner">
      <Container className="pt-5">
        <h1>Footer Banner Preview</h1>
      </Container>

      <div className="mobile-preview-section">
        <Container className="pt-5">
          <h3>Mobile Banner</h3>
          <div className="mobile-preview-footer-banner-container">
            <FooterBanner
              mobileOverride
              url={footer.url}
              background={get(background, 'img')}
              mobileBackground={get(mobileBackground, 'img')}
              foreground={get(foreground, 'img')}
              footerBannerName={footer.name}
            />
          </div>
        </Container>
      </div>

      <div className="desktop-preview-section">
        <Container className="pt-5">
          <h3>Desktop Banner</h3>
        </Container>
        <FooterBanner
          url={footer.url}
          background={get(background, 'img')}
          mobileBackground={get(mobileBackground, 'img')}
          foreground={get(foreground, 'img')}
          footerBannerName={footer.name}
        />
      </div>
    </div>
  );
};

PreviewFooterBanner.propTypes = {
  footer: PropTypes.shape({}),
};

PreviewFooterBanner.defaultProps = {
  footer: {},
};

export default PreviewFooterBanner;
